import { useEffect } from 'react';
import i18next from 'i18next';

export const useSetLocale = (targetLocale: string | undefined): void => {
  useEffect(() => {
    if (targetLocale && targetLocale !== i18next.language) {
      void i18next.changeLanguage(targetLocale);
    }
  }, [targetLocale]);
};
